import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const InfoSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default InfoSVG;
